import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class JobsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}/aias/modal/${
              item.id
            }`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}/aias/modal/${
              item.id
            }`
            return (
              <a href={jobUrl} target="_blank">
                {item.number}
              </a>
            )
          }
        }
      },
      {
        title: 'Job ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}`
            return (
              <a href={jobUrl} target="_blank">
                {item.job_id}
              </a>
            )
          }
        }
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        sorter: (a, b) => a.job_name.localeCompare(b.job_name)
      },
      {
        title: 'Company',
        dataIndex: 'company_name',
        sorter: (a, b) => a.company_name.localeCompare(b.company_name)
      },
      {
        title: 'Internal Amount',
        dataIndex: 'internal_amount_formatted'
      },
      {
        title: 'Vendor Amount',
        dataIndex: 'vendor_amount_formatted'
      },
      {
        title: 'Total Amount',
        dataIndex: 'total_amount'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'AIA Date',
        dataIndex: 'aia_date',
        sorter: (a, b) => {
          if (moment(a.aia_date).isBefore(moment(b.aia_date))) {
            return -1
          }
          return 1
        }
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item.key = item.id
      item.total_amount = numeral(item.internal_amount + item.vendor_amount).format('$0,0.00')
      item.aia_date = moment(new Date(item.aia_date)).format('YYYY-MM-DD')
      item.internal_amount_formatted = numeral(item.internal_amount).format('$0,0.00')
      item.vendor_amount_formatted = numeral(item.vendor_amount).format('$0,0.00')
      item.job = {
        job_id: item.job_id,
        job_type: item.job_type,
        number: item.number,
        id: item.id
      }
      return item
    })
    return data
  }

  getInternalAmountTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.internal_amount
    })
    return sum
  }

  getVendorAmountTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.vendor_amount
    })
    return sum
  }

  getTotals() {
    const total_value = numeral(this.getInternalAmountTotal() + this.getVendorAmountTotal()).format(
      '$0,0.00'
    )
    return {
      total_amount: total_value,
      internal_amount: numeral(this.getInternalAmountTotal()).format('$0,0.00'),
      vendor_amount: numeral(this.getVendorAmountTotal()).format('$0,0.00')
    }
  }

  tableComponents = (totals, key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td />
          <td />
          <td className="padding8">{totals.internal_amount}</td>
          <td className="padding8">{totals.vendor_amount}</td>
          <td className="padding8">{totals.total_amount}</td>
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              components={{ table: this.tableComponents(this.getTotals()) }}
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default JobsAdded



// WEBPACK FOOTER //
// ./src/components/reports/financial/aias-report/ListItems.js